import type { LabTab } from './LabShell.js';

export interface LabRoute {
  tab: LabTab;
  slug?: string;
}

export function parseHash(hash: string): LabRoute | null {
  const trimmed = hash.replace(/^#\/?/, '');
  if (!trimmed.startsWith('lab/')) return null;
  const parts = trimmed.split('/').filter(Boolean);
  const tab = parts[1] as LabTab | undefined;
  if (!tab) return null;
  const slug = parts.slice(2).join('/') || undefined;
  const valid: LabTab[] = ['overview', 'scan', 'bench', 'compare', 'routing', 'directory', 'receipts'];
  if (valid.includes(tab as LabTab)) {
    return { tab: tab as LabTab, slug };
  }
  return null;
}

export function buildHash(route: LabRoute): string {
  const base = `#/lab/${route.tab}`;
  return route.slug ? `${base}/${route.slug}` : base;
}

export function setHash(route: LabRoute): void {
  if (typeof window === 'undefined') return;
  const next = buildHash(route);
  if (window.location.hash !== next) {
    window.history.replaceState(null, '', next);
  }
}

export function subscribeHash(listener: (route: LabRoute | null) => void): () => void {
  if (typeof window === 'undefined') return () => {};
  const handler = () => listener(parseHash(window.location.hash));
  window.addEventListener('hashchange', handler);
  handler();
  return () => window.removeEventListener('hashchange', handler);
}
